



import React, { useState, useEffect, useRef, useCallback } from "react";
import { Button, Input, Select, Tag, Collapse, Empty } from "antd";
import { SearchOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import {
  Customstyles,
  silentRemoveAllSpans,
  silentRemoveActiveSpans,
  markSpanRejected,
  acceptSpan,
} from "../../components/styles/Customstyles";
 
const { Option } = Select;
const { Panel }  = Collapse;



 
export const SuggestionsData = ({ selectedStyles = [], editor, applyTrigger = 0 }) => {
  const [suggestions, setSuggestions] = useState([]);
  const [filter, setFilter]  = useState("all");
  const [searchTerm, setSearchTerm] = useState("");
 
  const editorRef   = useRef(editor);
  const scanningRef = useRef(false);
  const prevTrigger = useRef(-1);
  const debounceRef = useRef(null);
 
 
  const clearedRef  = useRef(false);
 
  useEffect(() => { editorRef.current = editor; }, [editor]);
 
  // Core scan
  const doScan = useCallback(() => {
    const ed = editorRef.current;
    if (!ed || !selectedStyles.length) { setSuggestions([]); return; }
    if (scanningRef.current) return;
 
   
    if (clearedRef.current) return;
 
    scanningRef.current = true;
    try {
      silentRemoveActiveSpans(ed);
      const newSuggestions = [];
      selectedStyles.forEach(styleId => {
        const style   = Customstyles[styleId];
        if (!style) return;
        const matches = style.execute(ed);
        if (!matches || !matches.length) return;
        newSuggestions.push({
          id: styleId, label: style.name,
          items: matches.map(m => ({ ...m, status: "pending" })),
        });
      });
      setSuggestions(newSuggestions);
    } finally {
      scanningRef.current = false;
    }
  }, [selectedStyles]);
 
  const doScanWithCursor = useCallback(() => {
    // const ed = editorRef.current;
    // if (!ed) return;
 
   
    // if (clearedRef.current) return;
 
    // let bookmark = null;
    // try { bookmark = ed.selection.getBookmark(2, true); } catch (_) {}
    // doScan();
    // if (bookmark) {
    //   requestAnimationFrame(() => {
    //     try { editorRef.current?.selection.moveToBookmark(bookmark); } catch (_) {}
    //   });
    // }


    const ed = editorRef.current;
    if (!ed) return;
    if (clearedRef.current) return;

    
    ed.selection.getContent(); 
    const markerId = "cursor-marker-" + Math.random().toString(36).slice(2, 9);
    ed.selection.collapse(true);
    ed.selection.setContent(`<span id="${markerId}"></span>`);

    
    doScan();

    
    setTimeout(() => {
      const doc = ed.getDoc();
      const marker = doc.getElementById(markerId);
      if (marker) {
        ed.selection.select(marker);
        ed.selection.collapse(true); 
        marker.remove();
        ed.focus();
      }
    }, 50); 

    
  }, [doScan]);
 
 
  useEffect(() => {
    if (!editor) return;
    if (applyTrigger === prevTrigger.current) return;
    prevTrigger.current = applyTrigger;
 
   
    clearedRef.current = false;
 
    silentRemoveAllSpans(editor);
    doScan();
  }, [applyTrigger, editor, doScan]);
 
  
  useEffect(() => {
    const ed = editorRef.current;
    if (!ed || !selectedStyles.length) return;
    const onInput = () => {
      if (prevTrigger.current < 0) return;
 
     
      if (clearedRef.current) return;
 
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(doScanWithCursor, 1000);
    };
    ed.on("input", onInput);
    return () => { ed.off("input", onInput); clearTimeout(debounceRef.current); };
  }, [editor, selectedStyles, doScanWithCursor]);
 
  // Trigger 3: Undo/Redo
  useEffect(() => {
    const ed = editorRef.current;
    if (!ed || !selectedStyles.length) return;
    const onUndoRedo = () => {
      if (prevTrigger.current < 0) return;
 
     
      if (clearedRef.current) {
       
        silentRemoveAllSpans(ed);
        return;
      }
 
      clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        silentRemoveAllSpans(ed);
        doScan();
      }, 80);
    };
    ed.on("Undo Redo", onUndoRedo);
    return () => ed.off("Undo Redo", onUndoRedo);
  }, [editor, selectedStyles, doScan]);
 
  // Trigger 4: Popup Accept sync
  useEffect(() => {
    const handler = (e) => {
      const { uid } = e.detail;
      setSuggestions(prev =>
        prev.map(s => ({ ...s, items: s.items.filter(it => it.uid !== uid) }))
            .filter(s => s.items.length > 0)
      );
    };
    window.addEventListener("suggestion-accepted", handler);
    return () => window.removeEventListener("suggestion-accepted", handler);
  }, []);

  // Trigger 4: Popup Ignore sync

  useEffect(() => {
  const handler = (e) => {
    const { uid } = e.detail;

    setSuggestions(prev =>
      prev.map(s => ({
        ...s,
        items: s.items.filter(it => it.uid !== uid)
      })).filter(s => s.items.length > 0)
    );
  };

  window.addEventListener("suggestion-rejected", handler);

  return () => window.removeEventListener("suggestion-rejected", handler);
}, []);
 
  //Accept
  const handleAccept = (suggestionId, itemIndex) => {
    const s = suggestions.find(s => s.id === suggestionId); if (!s) return;
    const item = s.items[itemIndex]; if (!item) return;
    const ed = editorRef.current; if (!ed) return;
    ed.undoManager.transact(() => acceptSpan(ed, item.uid, item.suggested));
    setSuggestions(prev =>
      prev.map(sg => sg.id !== suggestionId ? sg :
        { ...sg, items: sg.items.filter((_, i) => i !== itemIndex) })
          .filter(sg => sg.items.length > 0)
    );
  };
 
  // Reject
  const handleReject = (suggestionId, itemIndex) => {
    const s = suggestions.find(s => s.id === suggestionId); if (!s) return;
    const item = s.items[itemIndex]; if (!item) return;
    const ed = editorRef.current; if (!ed) return;
    markSpanRejected(ed, item.uid);
    setSuggestions(prev =>
      prev.map(sg => sg.id !== suggestionId ? sg :
        { ...sg, items: sg.items.filter((_, i) => i !== itemIndex) })
          .filter(sg => sg.items.length > 0)
    );
  };
 
  //Accept All
  const handleAcceptAll = (suggestionId) => {
    const s = suggestions.find(s => s.id === suggestionId); if (!s) return;
    const ed = editorRef.current; if (!ed) return;
    ed.undoManager.transact(() => {
      s.items.forEach(item => acceptSpan(ed, item.uid, item.suggested));
    });
    setSuggestions(prev => prev.filter(sg => sg.id !== suggestionId));
  };
 
  //Reject All
  const handleRejectAll = (suggestionId) => {
    const s = suggestions.find(s => s.id === suggestionId); if (!s) return;
    const ed = editorRef.current; if (!ed) return;
    s.items.forEach(item => markSpanRejected(ed, item.uid));
    setSuggestions(prev => prev.filter(sg => sg.id !== suggestionId));
  };
 
 
  const handleClearAll = () => {
    const ed = editorRef.current; if (!ed) return;    
    silentRemoveAllSpans(ed);
    clearedRef.current = false;    
    prevTrigger.current = -1; 
    setSuggestions([]);
  };
 
  //Scroll
  const scrollToSuggestion = (item) => {
    // const ed  = editorRef.current;
    // const doc = ed?.getDoc(); if (!doc) return;
    // const span = doc.querySelector(`span[data-suggestion-uid="${item.uid}"]`);
    // if (!span) return;
    // span.scrollIntoView({ behavior: "smooth", block: "center" });
    // const rng = doc.createRange();
    // rng.selectNodeContents(span);
    // ed.selection.setRng(rng);
    // ed.focus();

    const ed  = editorRef.current;
    const doc = ed?.getDoc(); 
    if (!doc) return;

    const span = doc.querySelector(`span[data-suggestion-uid="${item.uid}"]`);
    if (!span) return;

    
    span.scrollIntoView({ behavior: "smooth", block: "center" });

    
    const rng = doc.createRange();
    
    
    const nextNode = span.nextSibling;
    
    if (nextNode && nextNode.nodeType === 3 && nextNode.textContent.includes('\u200B')) {
      
      rng.setStart(nextNode, 1); 
      rng.collapse(true);
    } else {
      
      rng.setStartAfter(span);
      rng.collapse(true);
    }

    ed.selection.setRng(rng);
    ed.focus();
  };
 
  const filteredSuggestions = suggestions
    .filter(s => s.label.toLowerCase().includes(searchTerm.toLowerCase()))
    .filter(s => filter === "all" || s.items.some(it => it.status === filter));
  const totalSuggestions = filteredSuggestions.reduce((sum, s) => sum + s.items.length, 0);
 
  const panelHeader = (suggestion) => {
    const pendingCount = suggestion.items.filter(it => it.status === "pending").length;
    return (
      <div className="flex flex-col items-start w-full gap-4">
        <div className="flex items-center justify-between w-full gap-2">
          <span className="font-bold">{suggestion.label}</span>
          <Tag color="blue">{pendingCount}</Tag>
        </div>
        <div className="flex gap-2">
          <Button size="small" className="bg-white"
            icon={<CheckOutlined style={{ color: "green" }} />}
            onClick={(e) => { e.stopPropagation(); handleAcceptAll(suggestion.id); }}
          >Accept All</Button>
          <Button size="small" className="bg-white danger-custom-btn"
            icon={<CloseOutlined style={{ color: "red" }} />}
            onClick={(e) => { e.stopPropagation(); handleRejectAll(suggestion.id); }}
          >Reject All</Button>
        </div>
      </div>
    );
  };
 
  return (
    <div className="h-full flex flex-col">
      <div className="flex flex-col items-start p-4 pl-0 border-b gap-2">
        <h2 className="text-lg font-medium flex justify-between items-center w-full">
          Suggestions ({totalSuggestions})
          <button className="text-blue-500 hover:underline text-lg font-medium"
            onClick={handleClearAll}>Clear All</button>
        </h2>
        <div className="flex gap-2 w-full">
          <Input placeholder="Search styles..." className="flex-1"
            prefix={<SearchOutlined />} value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)} />
          {/* <Select value={filter} onChange={setFilter} className="w-32">
            <Option value="all">All</Option>
            <Option value="pending">Pending</Option>
            <Option value="accepted">Accepted</Option>
          </Select> */}
        </div>
      </div>
 
      {filteredSuggestions.length > 0 ? (
        <div className="flex-1 overflow-auto p-3 pl-0 sugest-item">
          <Collapse accordion={false} bordered={false}>
            {filteredSuggestions.map(suggestion => (
              <Panel header={panelHeader(suggestion)} key={suggestion.id}>
                {suggestion.items.map((item, index) => (
                  <div key={index}
                    className="mb-4 pb-2 flex justify-between items-center border-b border-dashed border-gray-300 cursor-pointer"
                    onClick={() => scrollToSuggestion(item)}>
                    <div className="flex flex-col">
                      <div className="flex gap-2 items-center">
                        <div className="text-sm text-red font-bold">Original:</div>
                        <div className="text-black font-bold">{item.text}</div>
                      </div>
                      <div className="flex gap-2 items-center">
                        <div className="text-sm text-green font-bold">Suggested:</div>
                        <div className="text-black font-bold">{item.suggested}</div>
                      </div>
                    </div>
                    <div className="flex gap-2 mt-2">
                      <Button type="primary" icon={<CheckOutlined />} size="small"
                        disabled={item.status !== "pending"}
                        onClick={(e) => { e.stopPropagation(); handleAccept(suggestion.id, index); }} />
                      <Button danger icon={<CloseOutlined />} size="small"
                        onClick={(e) => { e.stopPropagation(); handleReject(suggestion.id, index); }} />
                    </div>
                  </div>
                ))}
              </Panel>
            ))}
          </Collapse>
        </div>
      ) : (
        <div className="flex-1 flex items-center justify-center p-8">
          <Empty description={
            selectedStyles.length > 0
              ? "No suggestions found for the selected styles."
              : "Please select styles to see suggestions."
          } />
        </div>
      )}
    </div>
  );
};























